import React from 'react';

import '../App.css';

function Imprint() {
  return (
    <div className="imprint">
      <div>
        <div>
          <div>
            <div>
              <h3>Betreiber der Website und Anschrift</h3>
              <p>
                Progressive Mind GmbH
                <br />
                Tesdorpfstr. 21
                <br />
                20148 Hamburg
                <br />
                Germany
                <br />
                Telefon: +49 40 46 89 67 68 0<br />
                E-Mail:{' '}
                <a href="mailto:info@progressive-mind.com">
                  info@progressive-mind.com
                </a>
              </p>
              <p>
                <a
                  href="https://www.handelsregister.de/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Amtsgericht Hamburg HRB 160848
                </a>
                <br />
                USt-IdNr: DE328081658
              </p>
              <h3>Haftungshinweis</h3>
              <p>
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine
                Haftung für die Inhalte externer Links. Für den Inhalt der
                verlinkten Seiten sind ausschließlich deren Betreiber
                verantwortlich.
              </p>
            </div>
          </div>
        </div>
        <div>
          <div>
            <div>
              <h3>Geschäftsführung</h3>
              <p>
                Arno Hoffrichter und Florian Wessling sind die Geschäftsführer
                der Progressive Mind GmbH.
              </p>
            </div>
          </div>
          <div>
            <div>
              <h3>Urheberrecht</h3>
              <p>
                Alle Texte, Bilder und Grafiken sind urheberrechtlich geschützt.
                Die Veröffentlichung, Übernahme oder Nutzung von Texten, Bildern
                oder anderen Daten bedarf der schriftlichen Zustimmung.
              </p>
              <h3>Datenschutzbestimmungen</h3>
              <p>
                Die geltenden{' '}
                <a href="https://progressive-mind.com/datenschutzbestimmungen/">
                  Datenschutzbestimmungen finden Sie hier
                </a>
                .
              </p>
            </div>
          </div>
          <div>
            <div>
              <h3>Hinweise zu Schlichtungsverfahren</h3>
              <p>
                Die EU-Kommission hat eine Internetseite zur
                Online-Streitbeilegung zwischen Unternehmern und Verbrauchern
                (OS-Plattform) eingerichtet, die Sie unter
                http://ec.europa.eu/consumers/odr/ erreichen.
              </p>
            </div>
          </div>
        </div>
      </div>
      <h2>Attribution</h2>
      <p>
        Rain in forest - by inchadney CC-BY, rbh thunder storm (storm with rain)
        - by RHumphries, CC-BY, Storm by Erdie, CC-BY, SummerEveningInMyGarden,
        by acclivity - CC-BY-NC, AMBIENT LOOP - Perfectly Clear - Wilderness
        Hillside - FILTERED, by Arctura - CC-BY, Vent - wind(1) by Glaneur de
        sons - CC-BY, oceanwavescrushing.wav by Luftrum - CC-BY, fireplace by
        martats - CC-0, 131024_brook_black_forest.wav by reinsamba - CC-BY,
      </p>
    </div>
  );
}

export default Imprint;
